<template>
  <div class="header-component mb8 flex-row p16 width100">
    <!-- Start HOOK_TOP -->
    <i class="hkfi-back fs-14 bold mr12" @click="handleBackButtonClick"></i>
    <home-page-user-address :fullWidth="true"></home-page-user-address>
    <!-- <profile-icon></profile-icon> -->
    <!-- eof HOOK_TOP -->
  </div>
</template>

<script>
import Utility from "../helpers/utility";
import ProfileIcon from "./ProfileIcon.vue";
import HomePageUserAddress from "./HomePageUserAddress.vue";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { keyMapsMutation, keyMapsAction } from "../helpers/storeKeys";

export default {
  name: "TakeAwayPageHeader",
  components: {
    ProfileIcon,
    HomePageUserAddress,
  },
  data() {
    return {};
  },
  methods: {
    handleBackButtonClick(e) {
      if (
        !LocalStorageFunc.getDeliveryTypeStationData() ||
        (LocalStorageFunc.getDeliveryTypeStationData() &&
          !Object.keys(LocalStorageFunc.getDeliveryTypeStationData()).length)
      ) {
        LocalStorageFunc.setDeliveryType("D");
        this.$store.commit(keyMapsMutation.UPDATE_CURRENT_ORDER_TYPE, "D");
      } else {
        LocalStorageFunc.setDeliveryType(
          this.$store.state.User.currentOrderType
        );
      }
      LocalStorageFunc.setIsAddEditAddressFlow(false);
      LocalStorageFunc.setCoordsForAddEditAddress({});
      LocalStorageFunc.setSelectedChangedLocationForTwyDinein({});
      Utility.redirectToHomeOrRedirectUrl([
        { name: "changeTriggerFromDineinTwy", value: false },
      ]);
    },
  },
  watch: {},
  computed: {
    currentOrderType() {
      return this.$store.state.User.currentOrderType;
    },
  },
};
</script>

<style></style>
